import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { ApiService } from './services/api.service';
import { VersionCheckService } from './services/version-check.service';
import { OkDialogComponent } from './dialogs/ok-dialog/ok-dialog.component';
import { Store } from './helpers/store';
import { YesNoDialogComponent } from './dialogs/yes-no-dialog/yes-no-dialog.component';
import { DialogService } from './services/dialog.service';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    OkDialogComponent, YesNoDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,

    MatStepperModule, MatRadioModule, MatButtonModule, MatIconModule, MatInputModule, MatDialogModule, MatTooltipModule,
    MatProgressSpinnerModule,
  ],
  providers: [ApiService, VersionCheckService, DialogService, Store],
  entryComponents: [
    OkDialogComponent, YesNoDialogComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
